module.exports = __webpack_public_path__ + "static/media/upload_success.e81e069d.svg";